export default {
  API_ERROR: "Sajnáljuk, valami hiba történt. Kérjük, próbáld újra.",
  FORM_ERROR: "Sajnáljuk, de kérjük, írj egy kicsit többet, hogy visszajelzést adhass nekünk."
}
